export const SET_EDIT_ROLE_DASHBOARDS_LOADED = "SET_EDIT_ROLE_DASHBOARDS_LOADED";

export const setEditRoleDashboardsLoaded = (editRoleDashboardsLoaded: boolean) => {
  return {
    editRoleDashboardsLoaded,
    type: SET_EDIT_ROLE_DASHBOARDS_LOADED
  };
};
